<template>
  <div style="z-index: 3;">
    <div
      class="placeholder-container"
      :class="{ 'inp-caret': caret, 'error': error}"
      ref="desktopSelect"
      @click="togglePopup(true)">
      <multiselect
        :close-on-select="closeOnSelect"
        :class="{ 'has-value': hasValue, 'acceptInp': valid}"
        :searchable="searchable"
        :value="value_"
        :name="name"
        :track-by="selectKey"
        :multiple="multiselect"
        :placeholder="null"
        :clear-on-select="clearOnSelect"
        :preserve-search="preserveSearch"
        :options="options"
        :popularTileOptions="popularTileOptions"
        :label="selectLabel"
        :show_labels="false"
        :disabled="disabled || isMobileOnly"
        :show-no-results="false"
        @search-change="searchInput"
        :allow-empty="multiselect"
        :custom-label="customLabel"
        @keydown.native="restrictAndEmit"
        :useFilteredBackend="useFilteredBackend"
        @input="$emit('input', filterByKey($event))"
        ref="select">
        <template v-slot:beforeList>
          <slot name="beforeList"></slot>
        </template>
        <template v-slot:option="{ option } ">
          <slot name="option" v-bind:option="option">
            {{ option[selectLabel] }}
          </slot>
        </template>
        <template slot="caret">
          <span v-show="false"></span>
        </template>
        <template slot="clear" slot-scope="props">
          <label :for="name" class="multiselect__ph">
            {{ placeholder }}
          </label>
          <i class="clearSelect" @click="clearSelect()" v-if="(props.search).length > 0 && clearSearchButton"></i>
        </template>
        <template slot="singleLabel">
          <template v-if="value_">
            <slot name="singleLabel" v-bind:item="value_"></slot>
          </template>
        </template>
        <template v-slot:tag="tag">
          <slot name="tag" v-bind="tag"></slot>
        </template>
      </multiselect>
    </div>
    <div class="error-input-message" v-if="error">
      <slot name="empty-input-error" >
        {{ $t('qic_error_empty_input') }}
      </slot>
    </div>
    <!-- mobile -->
    <Teleport to="body" v-if="showPopup && isMobileOnly">
      <div class="mobile-select">
        <div class="mobile-select__header">
          <div class="mobile-select__title">{{ placeholder }}</div>
          <div class="close-popup"
            @click="togglePopup(false)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </div>
        </div>
        <div class="placeholder-container selectBig"
          :class="{'error': error, 'outbound_Destination': multiselect}">
          <multiselect
            :close-on-select="closeOnSelect"
            :class="{ 'has-value': hasValue, 'acceptInp': valid }"
            :searchable="searchable"
            :value="value_"
            :name="name"
            :track-by="selectKey"
            :multiple="multiselect"
            :placeholder="null"
            :clear-on-select="clearOnSelect"
            :preserve-search="preserveSearch"
            :options="options"
            :popularTileOptions="popularTileOptions"
            :label="selectLabel"
            :show_labels="false"
            :disabled="disabled"
            :show-no-results="false"
            :allow-empty="multiselect"
            :custom-label="customLabel"
            @keydown.native="restrictAndEmit"
            @input="onMobileInput($event)"
            ref="select">
            <template v-slot:beforeList>
              <slot name="beforeList"></slot>
            </template>
            <template v-slot:option="{ option } ">
              <slot name="option" v-bind:option="option">
                {{ option[selectLabel] }}
              </slot>
            </template>
            <template slot="caret">
              <span v-show="false"></span>
            </template>
            <template slot="clear" slot-scope="props">
              <label :for="name" class="multiselect__ph">
                {{ placeholder }}
              </label>
              <i class="clearSelect" @click="clearSelect()" v-if="(props.search).length > 0 && clearSearchButton"></i>
            </template>
            <template slot="singleLabel">
              <template v-if="value_">
                <slot name="singleLabel" v-bind:item="value_"></slot>
              </template>
            </template>
            <template v-slot:tag="tag">
              <slot name="tag" v-bind="tag"></slot>
            </template>
          </multiselect>
        </div>
        <BaseButton
          v-if="multiselect"
          symbol="no"
          class="btn-select"
          @click="togglePopup(false)">
            {{ $t('qic_dropdown_save_button') }}
        </BaseButton>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { isMobileOnly } from 'mobile-device-detect'
import Multiselect from './Multiselect'
import Teleport from 'vue2-teleport'
import BaseButton from '../buttons/BaseButton'
import Vue from 'vue'
Vue.prototype.$vuescrollConfig = {
  bar: {
    background: '#b3c0c8',
    minSize: 0.055,
    keepShow: true,
    size: '6px'
  },
  rail: {
    gutterOfSide: '1px'
  }
}
export default {
  name: 'BaseSelectMobile',
  components: {
    Multiselect,
    BaseButton,
    Teleport
  },
  props: {
    value: {},
    name: { type: String, default: 'select' },
    selectLabel: {},
    selectKey: {},
    placeholder: {},
    options: { type: Array },
    popularTileOptions: { type: Array },
    multiselect: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    validIcon: {},
    caret: { type: Boolean, default: false },
    customLabel: {},
    searchable: { type: Boolean, default: false },
    closeOnSelect: { type: Boolean, default: true },
    clearSearchButton: { type: Boolean, default: false },
    clearOnSelect: { type: Boolean, default: true },
    preserveSearch: { type: Boolean, default: false },
    error: {},
    allowEmpty: { type: Boolean, default: true },
    useFilteredBackend: { type: Boolean, default: false }
  },
  data () {
    return {
      simplebar: null,
      showPopup: false
    }
  },
  computed: {
    value_ () {
      if (this.value === null) return null
      if (this.selectKey === undefined) return this.value
      if (this.multiselect) {
        return this.options.filter((item) => this.value.includes(item[this.selectKey]))
      } else {
        return this.options.find((item) => this.value === item[this.selectKey])
      }
    },
    hasValue () {
      return this.multiselect ? this.value.length : !!this.value
    },
    valid () {
      return this.validIcon && this.hasValue
    },
    isMobileOnly () {
      return isMobileOnly
    }
  },
  mounted () {
    window.addEventListener('scroll', this.selectPosition)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.selectPosition)
  },
  methods: {
    searchInput (searchValue) {
      this.$emit('search', searchValue)
    },
    restrictAndEmit (event) {
      this.$emit('keydown', event)
    },
    selectPosition () {
      const rect = this.$refs.desktopSelect.getBoundingClientRect()
      const windowHeight = window.innerHeight || document.documentElement.clientHeight

      if (windowHeight - rect.bottom >= 0 && windowHeight - rect.bottom <= 310) {
        this.$refs.desktopSelect.classList.add('select-position-top')
      } else {
        this.$refs.desktopSelect.classList.remove('select-position-top')
      }
    },
    filterByKey (value) {
      if (!value) return value
      if (this.selectKey === undefined) return value
      if (this.multiselect) {
        return value.map((item) => item[this.selectKey])
      } else {
        return value[this.selectKey]
      }
    },
    clearSelect () {
      this.$refs.select.search = ''
    },
    togglePopup (value) {
      const body = document.querySelector('body')
      if (this.disabled) {
        this.showPopup = false
        body.classList.remove('overflow-off')
        return
      }
      if (value && isMobileOnly) {
        body.classList.add('overflow-off')
      } else {
        body.classList.remove('overflow-off')
      }
      this.showPopup = value
    },
    onMobileInput (value) {
      if (!this.multiselect) {
        this.togglePopup(false)
      }
      this.$emit('input', this.filterByKey(value))
    }
  }
}
</script>

<style lang="scss" scoped>
  .placeholder-container {
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);
    transform: translateZ(0);
  }
  .error-input-message {
    color: #ef3030;
    font-size: 12px;
    line-height: 1;
    margin-top: 8px;
  }
</style>

<style lang="scss">
.hasOptions {
    & .multiselect__content-wrapper {
      border: none;
    }
  }
.__bar-wrap-is-vertical {
   margin-top: 12px!important;
   margin-bottom: 12px!important;
}
.__bar-is-vertical{
  border-radius: 100px!important;
}
.multiselect {
  background-color: #F1F4F6;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 30px 20px 15px 20px;
  height: 56px;
  width: 100%;
  border: 1px solid #F1F4F6;
  outline: none;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.02em;
  transition: .3s;
  font-weight: 300;
  color: #141414;
  &:hover {
    border: 1px solid #DAE2E8;
    box-shadow: 0px 0px 0px 4px #EBF4FF;
  }

  &.multiselect--active {
    border: 1px solid rgba(43, 39, 255, 0.8);
    box-shadow: 0px 0px 0px 4px rgba(43, 39, 255, 0.15);
    & .clearSelect{
      display:block;
      opacity: 1;
    }
    &.acceptInp {
      background:white;
    }
  }

  &.multiselect--active, &.has-value {
    & label.multiselect__ph {
      top: 7px;
      left: 20px;
      font-size: 12px;
      line-height: 18px;
      color: rgba(82, 108, 130, 0.8);
    }
  }

  & .multiselect__placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    align-items: center;
    letter-spacing: -0.02em;
    color: #778A99;
    pointer-events: none;
    position: absolute;
    transition: all 200ms;
    top: 31%;
    left: 20px;
  }

  & .multiselect__single {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    align-items: center;
    letter-spacing: -0.02em;
    pointer-events: none;
    position: absolute;
    transition: all 200ms;
    top: 23px;
    left: 20px;
  }

  & input {
    border: none;
    background: none;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    align-items: center;
    letter-spacing: -0.02em;
    pointer-events: none;
    // top: 41%;
    // left: 20px;
    padding: 20px 0 0 0;
  }
  & .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;
    box-sizing: content-box;
    margin: 0 -1px;
    width: 100%;
    overflow: hidden;
    z-index: 50;
    margin-top: 11px;
    left: 0;
    border: 1px solid #DAE2E8;
    border-radius: 16px;
    max-height: 330px;
    & .multiselect__content {
      max-height: 300px;
      list-style: none;
      display: inline-block;
      padding: 0;
      margin: 0;
      min-width: 100%;
      vertical-align: top;
    }

    & .multiselect__option {
      padding: 16px;
      align-items: center;
      display: flex;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: -0.02em;
      color: #141414;
      cursor: pointer;
      transition: .3s;

      &:hover {
        background: #F1F4F6;
      }

      & img {
        margin-right: 8px;
        width: 24px;
      }
    }
  }
}

.select-position-top{
  .multiselect__content-wrapper{
    max-height: 250px !important;
  }
  .multiselect__content{
    max-height: 230px !important;
  }
}
</style>
